import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Car, CalendarClock, Navigation, History, Headphones, ArrowLeft, User, Wallet, LogOut, FileText, MapPin } from "lucide-react";

const cards = [
  { key: "book", label: "Reserver une course", icon: Car, route: "/quick-booking", requiresAuth: false, color: "emerald" },
  { key: "share-location", label: "Partager ma position", icon: MapPin, route: "/share-location", requiresAuth: false, color: "red" },
  { key: "profile", label: "Mon Profil", icon: User, route: "/client/profile", requiresAuth: true, color: "zinc" },
  { key: "wallet", label: "Ma Cagnotte", icon: Wallet, route: "/dashboard", requiresAuth: true, color: "amber" },
  { key: "invoices", label: "Factures", icon: FileText, route: "/client/invoices", requiresAuth: true, color: "indigo" },
  { key: "upcoming", label: "Courses a venir", icon: CalendarClock, route: "/client/upcoming", requiresAuth: true, color: "blue" },
  { key: "current", label: "Course en cours", icon: Navigation, route: "/client/current", requiresAuth: true, color: "yellow" },
  { key: "history", label: "Historique", icon: History, route: "/client/history", requiresAuth: true, color: "purple" },
  { key: "support", label: "Assistance", icon: Headphones, route: "/support", requiresAuth: false, color: "cyan" },
  { key: "logout", label: "Deconnexion", icon: LogOut, route: null, requiresAuth: true, color: "red" },
];

const colorMap = {
  emerald: { bg: "bg-emerald-500/15", icon: "text-emerald-400", border: "border-emerald-500/20", hover: "hover:border-emerald-500/50" },
  zinc: { bg: "bg-zinc-500/15", icon: "text-zinc-300", border: "border-zinc-500/20", hover: "hover:border-zinc-500/50" },
  amber: { bg: "bg-amber-500/15", icon: "text-amber-400", border: "border-amber-500/20", hover: "hover:border-amber-500/50" },
  blue: { bg: "bg-blue-500/15", icon: "text-blue-400", border: "border-blue-500/20", hover: "hover:border-blue-500/50" },
  yellow: { bg: "bg-yellow-500/15", icon: "text-yellow-400", border: "border-yellow-500/20", hover: "hover:border-yellow-500/50" },
  purple: { bg: "bg-purple-500/15", icon: "text-purple-400", border: "border-purple-500/20", hover: "hover:border-purple-500/50" },
  indigo: { bg: "bg-indigo-500/15", icon: "text-indigo-400", border: "border-indigo-500/20", hover: "hover:border-indigo-500/50" },
  red: { bg: "bg-red-500/15", icon: "text-red-400", border: "border-red-500/20", hover: "hover:border-red-500/50" },
  cyan: { bg: "bg-cyan-500/15", icon: "text-cyan-400", border: "border-cyan-500/20", hover: "hover:border-cyan-500/50" },
};

export const ClientCenterPage = () => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const handleClick = (card) => {
    if (card.key === 'logout') {
      logout();
      navigate('/');
      return;
    }
    if (card.requiresAuth && !user) {
      navigate(`/otp-login?redirect=${encodeURIComponent(card.route)}`);
    } else {
      navigate(card.route);
    }
  };

  return (
    <div className="min-h-screen bg-[#09090b]">
      <header className="px-4 py-4 border-b border-zinc-800">
        <div className="max-w-2xl mx-auto flex items-center gap-3">
          <button onClick={() => navigate("/")} className="p-2 rounded-lg hover:bg-zinc-800 transition-colors" data-testid="back-home-btn">
            <ArrowLeft className="w-5 h-5 text-zinc-400" />
          </button>
          <div className="flex items-center gap-2">
            <img src="/logo-youmi.png" alt="YOUMI" className="w-8 h-8" />
            <h1 className="text-lg font-bold text-white font-['Outfit']">Mon Profil</h1>
          </div>
        </div>
      </header>

      <main className="px-4 py-6 max-w-2xl mx-auto">
        <p className="text-zinc-400 text-sm mb-6">
          {user ? `Bonjour ${user.first_name}, que souhaitez-vous faire ?` : "Bienvenue, que souhaitez-vous faire ?"}
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-testid="client-grid">
          {cards.filter(card => card.key !== 'logout' || user).map((card) => {
            const c = colorMap[card.color];
            const Icon = card.icon;
            return (
              <button
                key={card.key}
                onClick={() => handleClick(card)}
                className={`flex items-center gap-4 p-5 rounded-xl border ${c.border} ${c.hover} bg-zinc-900/50 transition-all active:scale-[0.98] text-left w-full`}
                data-testid={`client-card-${card.key}`}
              >
                <div className={`w-12 h-12 rounded-xl ${c.bg} flex items-center justify-center shrink-0`}>
                  <Icon className={`w-6 h-6 ${c.icon}`} />
                </div>
                <span className="text-white font-medium text-sm">{card.label}</span>
              </button>
            );
          })}
        </div>
      </main>
    </div>
  );
};
